import * as actionTypes from "../actionTypes/actionTypes";
import { 
    getRegionsService, 
    getSalesOfficeService,
    getRolesService, 
    getUserRegionService, 
    getUserSalesOfficeService,
    getRegionBasedSalesOfficeService,
    createNewUserService,
    updateUserService,
    deleteUserService,
    getByRegionUserService
 } from "../services/UserServices";
 import * as _ from "lodash";
 const getRegionsList = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_U_REGIONS
        })
        window.startLoading();
        getRegionsService().then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_U_REGIONS_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_U_REGIONS_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const getSalesOfficeList = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_U_SALESOFFICE
        })
        window.startLoading();
        getSalesOfficeService().then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_U_SALESOFFICE_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_U_SALESOFFICE_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const getRolesList = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_U_ROLES
        })
        window.startLoading();
        getRolesService().then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_U_ROLES_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_U_ROLES_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const getUserRegionsList = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_USER_MAPPED_REGIONS
        })
        window.startLoading();
        getUserRegionService().then((response)=>{
          const data = response.data;
          const sortedUsers = _.sortBy(data, ['userName']);
            dispatch({
                type: actionTypes.GET_USER_MAPPED_REGIONS_SUCCESS,
                payload: sortedUsers
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_USER_MAPPED_REGIONS_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const getByRegionsUsersList = (regionLevelId) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.GET_BY_USER_MAPPED_REGIONS
      })
      window.startLoading();
      getByRegionUserService(regionLevelId).then((response)=>{
        const data = response.data;
        const sortedUsers = _.sortBy(data, ['userName']);
          dispatch({
              type: actionTypes.GET_BY_USER_MAPPED_REGIONS_SUCCESS,
              payload: sortedUsers
          })
      })
      .catch((error)=>{
        dispatch({
          type: actionTypes.GET_BY_USER_MAPPED_REGIONS_FAILURE,
          payload: error
      })
      }).finally(()=>{
        window.stopLoading();
      })
  }
}

const getUserSalesOfficeList = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_USER_MAPPED_SALESOFFICE
        })
        window.startLoading();
        getUserSalesOfficeService().then((response)=>{
          const data = response.data;
            dispatch({
                type: actionTypes.GET_USER_MAPPED_SALESOFFICE_SUCCESS,
                payload: data
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_USER_MAPPED_SALESOFFICE_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}

const getSelectedRegionsData = (regionSelectedData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.REGION_SELECTION,
      payload:regionSelectedData
    })
  }
}
const getSalesOfficeSelectedData = (salesOfficeSelectedData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.SALES_OFFICE_SELECTION,
      payload:salesOfficeSelectedData
    })
  }
}
const getRenderUsersListData = (userTableData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.USER_TABLE_DATA_CREATION,
      payload:userTableData
    })
  }
}

const getRegionBasedSalesOffice = (region) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.REGION_BASED_OFFICE_START
    })
    await getRegionBasedSalesOfficeService(region)
    .then((response) => {
      const data = response.data
      dispatch({
        type:actionTypes.REGION_BASED_OFFICE_SUCCESS,
        payload:data
      })
    })
    .catch((error) =>{
      dispatch({
        type:actionTypes.REGION_BASED_OFFICE_FAILURE,
        payload:error
      })
    })
  }
}

const createNewUser = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_USER_START,
    });
    console.log('testing payload',requestPayload);
    await createNewUserService(requestPayload)
      .then((response) => {
        console.log('tsing',response.data);
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_USER_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_USER_FAILURE,
          payload: error,
        });
      });
  };
};

const updateUserAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type:actionTypes.UPDATE_USER_START
    });
    await updateUserService(requestPayload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.UPDATE_USER_SUCCESS,
        payload:data
      });
    })
    .catch((error) => {
      dispatch({
        type:actionTypes.UPDATE_USER_FAILURE,
        payload:error
      })
    })
  }
}


const DeleteUserAction = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.DELETE_USER_START
    });
    await deleteUserService(requestPayload)
    .then((response) => {
      const data = response.data;
      dispatch({
        type:actionTypes.DELETE_USER_SUCCESS,
        payload:data
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.DELETE_USER_FAILURE,
        payload: error
      })
    })
  }
}

export {getRegionsList, getSalesOfficeList, getRolesList, getUserRegionsList, getUserSalesOfficeList,getSelectedRegionsData,getSalesOfficeSelectedData,getRenderUsersListData,getRegionBasedSalesOffice,createNewUser,updateUserAction,DeleteUserAction,getByRegionsUsersList };